import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, Card, Col, DatePicker, Empty, Form, Pagination, Row, Select, Table, Modal, message, Input } from 'antd';
import moment from 'moment';
import { ColumnProps } from 'antd/lib/table';
import { LotCodeOpsService } from '@gtpl/shared-services/production';
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
const { Option } = Select;

type LotInfoViewProps = {
  screen?: string;
};

const LotInfoView = ({ screen }: LotInfoViewProps) => {
  const [data, setData] = useState<any[]>([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [filterForm] = Form.useForm();
  const [lotNumbers, setLotNumbers] = useState<any[]>([])
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalData, setModalData] = useState<any[]>([]);
  const [modalPage, setModalPage] = useState(1);
  const modalPageSize = 10;
    const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef<any>(null);
  const service = new LotCodeOpsService();

  const getLotInfoViewData = () => {
    const req: any = {};
    if (filterForm.getFieldValue('fromLot')) {
      req.fromLot = filterForm.getFieldValue('fromLot');
    }

    if (filterForm.getFieldValue('toLot')) {
      req.toLot = filterForm.getFieldValue('toLot');
    }
    if (filterForm.getFieldValue('invoiceDate') && filterForm.getFieldValue('invoiceDate')[0]) {
      req.fromDate = (filterForm.getFieldValue('invoiceDate')[0]).format('YYYY-MM-DD');
      req.toDate = (filterForm.getFieldValue('invoiceDate')[1]).format('YYYY-MM-DD');
    }
    if (screen) {
      req.screen = screen;
    }
    service.getLotInfoViewData(req).then((res: any) => {

      if (res?.status) {
        setData(res.data || []);
      } else {
        setData([]);
      }
    }).catch(() => {
      setData([]);
    });
  };

  useEffect(() => {

  filterForm.setFieldsValue({
    invoiceDate: [
      moment().subtract(10, 'days'),
      moment()
    ]
  });

  getLotInfoViewData();
  getAllLotNumbers();

}, []);

  const getAllLotNumbers = () => {
    service.getFromToLotNumberDropdown().then((res) => {
      if (res.status) {
        setLotNumbers(res.data)
      } else {
        setLotNumbers([])
      }
    }).catch((err) => {
      setLotNumbers([])
    });
  }

  const onSearch = () => {

  const fromLot = filterForm.getFieldValue('fromLot');
  const toLot = filterForm.getFieldValue('toLot');

  if ((fromLot && !toLot) || (!fromLot && toLot)) {
    message.error('Please select both From Lot and To Lot');
    return;
  }

  if (fromLot && toLot) {

     const fromPrefix = fromLot.match(/^[A-Za-z]+/)?.[0];
  const toPrefix = toLot.match(/^[A-Za-z]+/)?.[0];

    if (fromPrefix !== toPrefix) {
      message.error('From Lot and To Lot should have same format');
      return;
    }
  }

  getLotInfoViewData();
  setPage(1);
};

  const onReset = () => {
    filterForm.resetFields();
    getLotInfoViewData();
    setPage(1);
  };

  useEffect(() => {
    const maxPage = Math.max(1, Math.ceil(data.length / pageSize));
    if (page > maxPage) setPage(1);
  }, [data.length, pageSize]);

  const tableData = useMemo(() => {
    const start = (page - 1) * pageSize;
    const paginated = data.slice(start, start + pageSize);
    return paginated.map((row, index) => ({
      ...row,
      key: `row-${start + index}`,
      sno: start + index + 1,
      baleDateFormatted: row.baleDate ? moment(row.baleDate).format('DD-MM-YYYY') : '-'
    }));
  }, [data, page, pageSize]);

  const handleLotClick = (record: any) => {
    const req: any = { baleDate: moment(record.baleDate).format('YYYY-MM-DD') };
    if (screen) {
      req.screen = screen;
    }
    service.getExportLotDetailView(req).then((res: any) => {
      if (res?.status) {
        const modalRows = (res.data || []).map((item: any, idx: number) => ({
          ...item,
          key: `modal-${idx}`,
          sno: idx + 1,
          baleDateFormatted: item.baleDate ? moment(item.baleDate).format('DD-MM-YYYY') : '-',
        }));
        setModalData(modalRows);
      } else {
        setModalData([]);
      }
      setModalPage(1);
      setIsModalVisible(true);
    }).catch(() => {
      setModalData([]);
      setModalPage(1);
      setIsModalVisible(true);
    });
  };

    function handleSearch(selectedKeys: any, confirm: any, dataIndex: any) {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  }

  function handleReset(clearFilters: any) {
    clearFilters();
    setSearchText("");
  }

  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() =>
            handleSearch(selectedKeys, confirm, dataIndex)
          }
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered: any) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value: any, record: any) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    render: (text: any) =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : (
          text
        )
      ) : null,
  });

  const paginatedModalData = useMemo(() => {
    const start = (modalPage - 1) * modalPageSize;
    return modalData.slice(start, start + modalPageSize);
  }, [modalData, modalPage]);

  const modelColumns: ColumnProps<any>[] = [
    {
      title: "S No",
      key: "sno",
      width: "70px",
      render: (text, object, index) => (page - 1) * 10 + (index + 1),
    },
{
  title: 'Bale Date',
  dataIndex: 'baleDateFormatted',
  align: 'left',
  sorter: (a, b) => (a.baleDateFormatted || '').localeCompare(b.baleDateFormatted || ''),
  sortDirections: ['descend', 'ascend'],
  ...getColumnSearchProps('baleDateFormatted'),
  render: (value) => value || '-'
},
    { title: 'Bale Number', dataIndex: 'baleNumber', key: 'baleNumber' ,
      sorter: (a, b) => (a.baleNumber || '').localeCompare(b.baleNumber || ''),
      ...getColumnSearchProps("baleNumber"),},
    { title: 'Lot Number', dataIndex: 'lotNumber', key: 'lotNumber' ,
      sorter: (a, b) => (a.lotNumber || '').localeCompare(b.lotNumber || ''),
      ...getColumnSearchProps("lotNumber"),},
    { title: 'Variant', dataIndex: 'variant', key: 'variant' ,sorter: (a, b) => (a.variant || '').localeCompare(b.variant || ''),
      ...getColumnSearchProps("variant"),},
    { title: 'Quality', dataIndex: 'quality', key: 'quality' ,
      sorter: (a, b) => (a.quality || '').localeCompare(b.quality || ''),
      ...getColumnSearchProps("quality"),},
    { title: 'Quantity', dataIndex: 'quantity', key: 'quantity' ,
      sorter: (a, b) => (a.quantity || '').localeCompare(b.quantity || ''),
      ...getColumnSearchProps("quantity"),
      render: (value) => Number(Number(value).toFixed(2))
    },
  ];

  const columns: ColumnProps<any>[] = [
    {
      title: "S No",
      key: "sno",
      width: "70px",
      render: (text, object, index) => (page - 1) * 10 + (index + 1),
    },
  {
  title: 'Bale Date',
  dataIndex: 'baleDateFormatted',
  align: 'left',
  sorter: (a, b) => (a.baleDateFormatted || '').localeCompare(b.baleDateFormatted || ''),
  sortDirections: ['descend', 'ascend'],
  ...getColumnSearchProps('baleDateFormatted'),
  render: (value) => value || '-'
},
    {
  title: 'From Lot- To Lot',
  dataIndex: 'lotRange',
  key: 'lotRange',

  sorter: (a, b) => (a.lotRange || '').localeCompare(b.lotRange || ''),
  ...getColumnSearchProps("lotRange"),

  render: (text, record) => (
    <a
      style={{
        color: '#1890ff',
        textDecoration: 'underline',
        cursor: 'pointer',
        fontWeight: 500
      }}
      onClick={() => handleLotClick(record)}
    >
      {text}
    </a>
  ),
},
  ];

  return (
    <Card title={<span style={{ color: 'white' }}>Export Lot Info</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}>
      <Form form={filterForm} layout='vertical'>
        <Row gutter={[16, 16]}>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 6 }}>
            <Form.Item name="invoiceDate" label="Bale Date">
              <DatePicker.RangePicker />
            </Form.Item>
          </Col>

          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
            <Form.Item name="fromLot" label="From Lot " >
              <Select
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => (option?.children as any)?.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Lot Number"
              >
                {lotNumbers.map((lotNum: any) => {
                  return (
                    <Option key={lotNum.lotNumber} value={lotNum.lotNumber}>
                      {lotNum.lotNumber}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 5 }} lg={{ span: 5 }} xl={{ span: 5 }}>
            <Form.Item name="toLot" label="To Lot " >
              <Select
                allowClear
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) => (option?.children as any)?.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                placeholder="Select Lot Number"
              >
                {lotNumbers.map((lotNum: any) => {
                  return (
                    <Option key={lotNum.lotNumber} value={lotNum.lotNumber}>
                      {lotNum.lotNumber}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }} style={{ marginTop: 28 }}>
            <Form.Item><Button type='primary' onClick={onSearch}>Search</Button></Form.Item>
          </Col>
          <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 4 }} lg={{ span: 4 }} xl={{ span: 2 }} style={{ marginTop: 28 }}>
            <Form.Item><Button danger onClick={onReset}>Reset</Button></Form.Item>
          </Col>
        </Row>
      </Form>
      <Table
        bordered
        columns={columns}
        dataSource={tableData}
        rowKey={(r) => r.key}
        pagination={false}
        locale={{ emptyText: <Empty description="No lot information found" /> }}
        size="small"
        style={{width:'100%',margin:'auto'}}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
        <Pagination
          current={page}
          pageSize={pageSize}
          total={data.length}
          showSizeChanger
          pageSizeOptions={['10', '20', '50', '100']}
          showTotal={(total) => `${total} record(s)`}
          onChange={(current, size) => {
            setPage(current);
            if (size && size !== pageSize) setPageSize(size);
          }}
          onShowSizeChange={(_current, size) => {
            setPage(1);
            setPageSize(size);
          }}
        />
      </div>

      <Modal
        title="Lot Details"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        width={1000}
      >
        <Table
          bordered
          columns={modelColumns}
          dataSource={paginatedModalData}
          rowKey={(r) => r.key}
          pagination={false}
          locale={{ emptyText: <Empty description="No lot details found" /> }}
          scroll={{ x: 'max-content' }}
        />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
          <Pagination
            current={modalPage}
            pageSize={modalPageSize}
            total={modalData.length}
            onChange={(current) => setModalPage(current)}
          />
        </div>
      </Modal>

    </Card>
  );
};

export default LotInfoView;